<template>
  <div>
    <div class="e-loader-back" v-if="loading">
      <div class="e-loader-content">
        <div class="ball-clip-rotate-multiple">
          <div></div>
          <div></div>
        </div>
        <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
      </div>
    </div>
    <h4
      class="
        d-flex
        justify-content-between
        align-items-center
        w-100
        font-weight-bold
        py-3
        mb-4
      "
    >
      <div class="e-mtavr-15">სკანირების პარამეტრები</div>
    </h4>
    <div class="row">
      <div class="col-12">
        <b-tabs class="nav-tabs-top nav-responsive-xl">
          <b-tab class="e-nusx-8" @click="JuridicalStatus = 1, filterScanningDatabases()">
            <template #title>
              <span class="e-nusx-8"> ფიზიკური პირი </span>
            </template>
            <div class="card-body">
              <div class="row pt-5 pb-5">
                <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12">
                  <!-- Register form -->
                  <b-form-group
                    label="დამთხვევის %"
                    class="e-nusx-8 e-bold text-muted"
                  >
                    <vue-slider
                      ref="Coinsidence_slider"
                      v-model="ParamsItem_PP.amlParameter.matchPercent"
                      :tooltip="'always'"
                      :min="75"
                    ></vue-slider>
                  </b-form-group>
                  <b-form-group
                    label="თქვენს მიერ შეძენილი გადამოწმების პაკეტი"
                    class="e-nusx-8 e-bold text-muted"
                  >
                    <i
                      class="badge badge-danger"
                      v-if="spIderrorMsg && SS.scanningPacketId === undefined"
                      >შეცდომა</i
                    ><span
                      class="e-nusx-8"
                      v-if="spIderrorMsg && SS.scanningPacketId === undefined"
                      ><small>გთხოვთ აირჩიოთ გადამოწმების პაკეტი</small></span
                    >
                    <b-form-radio
                      v-for="spack in scanningPackets"
                      :key="spack.$index"
                      v-model="ParamsItem_PP.amlParameter.scanningPacketId"
                      :value="spack.id"
                      class="m-0 font-weight-normal mt-1"
                      disabled
                      >{{ spack.name }}</b-form-radio
                    >
                  </b-form-group>
                  <b-form-group>
                    <button class="btn btn-primary" @click="saveSSSettings">
                      შენახვა
                    </button>
                    <button class="btn btn-secondary" @click="clearForm">
                      გასუფთავება
                    </button>
                  </b-form-group>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12">
                  <b-form-group
                    label="გადასამოწმებელი ბაზები"
                    class="e-nusx-8 e-bold text-muted"
                    v-if="ParamsItem_PP.amlParameter.scanningPacketId > 0"
                  >
                    <i
                      class="badge badge-danger"
                      v-if="dberrorMsg & (scannigPacketDatabases.length === 0)"
                      >შეცდომა</i
                    ><span
                      class="e-nusx-8"
                      v-if="dberrorMsg & (scannigPacketDatabases.length === 0)"
                      ><small>გთხოვთ აირჩიოთ გადამოწმების პაკეტი</small></span
                    >
                  </b-form-group>
                  <b-form-group>
                    <template #label>
                      <b-form-checkbox
                        v-model="allSelectedPP"
                        :indeterminate="indeterminatePP"
                        aria-describedby="scdb_PP"
                        aria-controls="scdb_PP"
                        @change="toggleAll"
                      >
                        {{ allSelectedPP ? "ყველა მონიშვნის გაუქმება" : "ყველას მონიშვნა" }}
                      </b-form-checkbox>
                    </template>

                    <template v-slot="{ ariaDescribedby }">
                      <b-form-checkbox-group
                        id="scdb_PP"
                        v-model="selectedPP"
                        :aria-describedby="ariaDescribedby"
                        name="scdb_PP"
                        aria-label="scdb_PP"
                        stacked
                      >
                        <b-form-checkbox
                          v-for="scdb_PP in scannigPacketDatabases"
                          :key="scdb_PP.id"
                          type="checkbox"
                          v-model="ParamsItem_PP.scannigPacketDatabases"
                          :value="scdb_PP"
                          class="mt-4"
                        >
                          <span class="e-text-eng-1 e-bold">{{
                            scdb_PP.name
                          }}</span>
                          <p>
                            <small class="e-text-eng-1">{{
                              scdb_PP.description
                            }}</small>
                          </p>
                        </b-form-checkbox>
                      </b-form-checkbox-group>
                    </template>
                  </b-form-group>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab class="e-nusx-8" @click="JuridicalStatus = 2, filterScanningDatabases()">
            <template #title>
              <span class="e-nusx-8"> იურიდიული პირი </span>
            </template>
            <div class="card-body">
              <div class="row pt-5 pb-5">
                <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12">
                  <!-- Register form -->
                  <b-form-group
                    label="დამთხვევის %"
                    class="e-nusx-8 e-bold text-muted"
                  >
                    <vue-slider
                      ref="Coinsidence_slider"
                      v-model="ParamsItem_LE.amlParameter.matchPercent"
                      :tooltip="'always'"
                      :min="75"
                    ></vue-slider>
                  </b-form-group>
                  <b-form-group
                    label="თქვენს მიერ შეძენილი გადამოწმების პაკეტი"
                    class="e-nusx-8 e-bold text-muted"
                  >
                    <i
                      class="badge badge-danger"
                      v-if="spIderrorMsg && SS.scanningPacketId === undefined"
                      >შეცდომა</i
                    ><span
                      class="e-nusx-8"
                      v-if="spIderrorMsg && SS.scanningPacketId === undefined"
                      ><small>გთხოვთ აირჩიოთ გადამოწმების პაკეტი</small></span
                    >
                    <b-form-radio
                      v-for="spack in scanningPackets"
                      :key="spack.$index"
                      v-model="ParamsItem_LE.amlParameter.scanningPacketId"
                      :value="spack.id"
                      class="m-0 font-weight-normal mt-1"
                      disabled
                      >{{ spack.name }}</b-form-radio
                    >
                  </b-form-group>
                  <b-form-group>
                    <button class="btn btn-primary" @click="saveSSSettings">
                      შენახვა
                    </button>
                    <button class="btn btn-secondary" @click="clearForm">
                      გასუფთავება
                    </button>
                  </b-form-group>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12">
                  <b-form-group
                    label="გადასამოწმებელი ბაზები"
                    class="e-nusx-8 e-bold text-muted"
                    v-if="ParamsItem_LE.amlParameter.scanningPacketId > 0"
                  >
                    <i
                      class="badge badge-danger"
                      v-if="dberrorMsg & (scannigPacketDatabases.length === 0)"
                      >შეცდომა</i
                    ><span
                      class="e-nusx-8"
                      v-if="dberrorMsg & (scannigPacketDatabases.length === 0)"
                      ><small>გთხოვთ აირჩიოთ გადამოწმების პაკეტი</small></span
                    >
                  </b-form-group>
                   <b-form-group>
                    <template #label>
                      <b-form-checkbox
                        v-model="allSelectedLE"
                        :indeterminate="indeterminateLE"
                        aria-describedby="scdb_LE"
                        aria-controls="scdb_LE"
                        @change="toggleAllLE"
                      >
                        {{ allSelectedLE ? "ყველა მონიშვნის გაუქმება" : "ყველას მონიშვნა" }}
                      </b-form-checkbox>
                    </template>

                    <template v-slot="{ ariaDescribedby }">
                      <b-form-checkbox-group
                        id="scdb_LE"
                        v-model="selectedLE"
                        :aria-describedby="ariaDescribedby"
                        name="scdb_LE"
                        aria-label="scdb_LE"
                        stacked
                      >
                        <b-form-checkbox
                          v-for="scdb_LE in scannigPacketDatabases"
                          :key="scdb_LE.id"
                          type="checkbox"
                          v-model="ParamsItem_LE.scannigPacketDatabases"
                          :value="scdb_LE"
                          class="mt-4"
                        >
                          <span class="e-text-eng-1 e-bold">{{
                            scdb_LE.name
                          }}</span>
                          <p>
                            <small class="e-text-eng-1">{{
                              scdb_LE.description
                            }}</small>
                          </p>
                        </b-form-checkbox>
                      </b-form-checkbox-group>
                    </template>
                  </b-form-group>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="px-4 px-sm-5 pt-4 pb-5 pb-sm-5">
          <div class="col-12 pl-0"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
import vueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/ething-material.css'
import 'loaders.css/loaders.css'
import 'spinkit/spinkit.css'
export default {
  components: {
    vueSlider
  },
  data () {
    return {
      flavours: ['Orange', 'Grape', 'Apple', 'Lime', 'Very Berry'],
      saveActionType: '',
      loading: false,
      ss: true,
      dberrorMsg: false,
      spIderrorMsg: false,
      scanningPackets: this.$store.getters.GetscanningPackets,
      scannigPacketDatabases: this.$store.getters.GetscannigPacketDatabases,
      purchasedScanningPackage: this.$store.getters.GetPurchasedScanningPacket,
      ScreeningSettings: true,
      // SS: {
      //   scannigPacketDatabases: [],
      //   matchPercent: 80
      // },
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      JuridicalStatus: 1,
      ParamsItem_PP: {
        amlParameter: {
          id: 0,
          organisationId: 0,
          juridicalStatusId: 1,
          paramterTypeId: 1,
          parameterTypeName: 'scanning',
          scanningPacketId: 0,
          scanningDatabases: '',
          matchPercent: 75,
          checkInAcuris: true,
          logic1: false,
          logic2: false,
          logic3: false,
          organisationUserId: 0
        },
        scannigPacketDatabases: []
      },
      ParamsItem_LE: {
        amlParameter: {
          id: 0,
          organisationId: 0,
          juridicalStatusId: 2,
          paramterTypeId: 1,
          parameterTypeName: 'scanning',
          scanningPacketId: 0,
          scanningDatabases: '',
          matchPercent: 75,
          checkInAcuris: true,
          logic1: false,
          logic2: false,
          logic3: false,
          organisationUserId: 0
        },
        scannigPacketDatabases: [
          {
            id: 0,
            name: '',
            description: '',
            nameGE: '',
            descriptionGE: '',
            scanningPacketID: 0,
            juridicalStatusId: 0,
            deleteStatus: true
          }
        ],
        selectedSPD: []
      },
      // newParamsItem_WLPP: {
      //   amlParameter: {
      //     id: 0,
      //     organisationId: 0,
      //     juridicalStatusId: 0,
      //     paramterTypeId: 1,
      //     parameterTypeName: 'scanning',
      //     scanningPacketId: 0,
      //     scanningDatabases: '',
      //     matchPercent: 0,
      //     checkInAcuris: true,
      //     logic1: false,
      //     logic2: false,
      //     logic3: false,
      //     organisationUserId: 0
      //   },
      //   scannigPacketDatabases: [
      //     {
      //       id: 0,
      //       name: '',
      //       description: '',
      //       scanningPacketID: 0,
      //       deleteStatus: true
      //     }
      //   ]
      // },
      // newParamsItem_WLLE: {
      //   amlParameter: {
      //     id: 0,
      //     organisationId: 0,
      //     juridicalStatusId: 0,
      //     paramterTypeId: 1,
      //     parameterTypeName: 'scanning',
      //     scanningPacketId: 0,
      //     scanningDatabases: '',
      //     matchPercent: 0,
      //     checkInAcuris: true,
      //     logic1: false,
      //     logic2: false,
      //     logic3: false,
      //     organisationUserId: 0
      //   },
      //   scannigPacketDatabases: [
      //     {
      //       id: 0,
      //       name: '',
      //       description: '',
      //       scanningPacketID: 0,
      //       deleteStatus: true
      //     }
      //   ]
      // },
      // newParamsItem_BLPP: {
      //   amlParameter: {
      //     id: 0,
      //     organisationId: 0,
      //     juridicalStatusId: 0,
      //     paramterTypeId: 1,
      //     parameterTypeName: 'scanning',
      //     scanningPacketId: 0,
      //     scanningDatabases: '',
      //     matchPercent: 0,
      //     checkInAcuris: true,
      //     logic1: false,
      //     logic2: false,
      //     logic3: false,
      //     organisationUserId: 0
      //   },
      //   scannigPacketDatabases: [
      //     {
      //       id: 0,
      //       name: '',
      //       description: '',
      //       scanningPacketID: 0,
      //       deleteStatus: true
      //     }
      //   ]
      // },
      // newParamsItem_BLLE: {
      //   amlParameter: {
      //     id: 0,
      //     organisationId: 0,
      //     juridicalStatusId: 0,
      //     paramterTypeId: 1,
      //     parameterTypeName: 'scanning',
      //     scanningPacketId: 0,
      //     scanningDatabases: '',
      //     matchPercent: 0,
      //     checkInAcuris: true,
      //     logic1: false,
      //     logic2: false,
      //     logic3: false,
      //     organisationUserId: 0
      //   },
      //   scannigPacketDatabases: [
      //     {
      //       id: 0,
      //       name: '',
      //       description: '',
      //       scanningPacketID: 0,
      //       deleteStatus: true
      //     }
      //   ]
      // },
      currentUser: this.$store.getters.GetCurrentUser,
      selectedPP: [],
      allSelectedPP: false,
      indeterminatePP: false,
      selectedLE: [],
      allSelectedLE: false,
      indeterminateLE: false
    }
  },
  created () {
    this.loading = true
    this.filterScanningDatabases()
    this.scannigPacketDatabases = this.scannigPacketDatabases.filter(
      (sdb) =>
        sdb.scanningPacketID === this.purchasedScanningPackage.scanningPacketId
      // (sdb) => sdb.scanningPacketID === this.purchasedScanningPackage
    )
    this.loadAmlParameters()
  },
  methods: {
    filterScanningDatabases () {
      this.scannigPacketDatabases = this.$store.getters.getFilteredPacketDatabases(this.JuridicalStatus)
      console.log(this.scannigPacketDatabases)
    },
    loadAmlParameters () {
      BaseService.GetAMLParameters(this.header).then((res) => {
        console.log(res)
        if (res.data.success) {
          if (res.data.result.length > 0) {
            for (var i = 0; i < res.data.result.length; i++) {
              if (
                res.data.result[i].amlParameter.juridicalStatusId === 1 &&
                res.data.result[i].amlParameter.paramterTypeId === 1
              ) {
                this.ParamsItem_PP = res.data.result[i]
              }
              if (
                res.data.result[i].amlParameter.juridicalStatusId === 2 &&
                res.data.result[i].amlParameter.paramterTypeId === 1
              ) {
                this.ParamsItem_LE = res.data.result[i]
              }
            }
          }
          this.ParamsItem_PP.amlParameter.scanningPacketId =
            this.purchasedScanningPackage.scanningPacketId
          this.ParamsItem_LE.amlParameter.scanningPacketId =
            this.purchasedScanningPackage.scanningPacketId
          this.loading = false
        }
        this.ParamsItem_PP.amlParameter.organisationId =
          this.currentUser.organizationID
        this.ParamsItem_LE.amlParameter.organisationId =
          this.currentUser.organizationID
      })
    },
    saveSSSettings () {
      let param = {}
      if (this.JuridicalStatus === 1) {
        param = this.ParamsItem_PP
        if (param.amlParameter.id > 0) {
          this.saveActionType = 'edit'
        } else {
          this.saveActionType = 'add'
        }
      } else if (this.JuridicalStatus === 2) {
        param = this.ParamsItem_LE
        if (param.amlParameter.id > 0) {
          this.saveActionType = 'edit'
        } else {
          this.saveActionType = 'add'
        }
      }
      console.log(param)
      if (this.saveActionType === 'add') {
        BaseService.AddAMLParameter(this.header, param).then((res) => {
          if (res.data.success) {
            if (this.JuridicalStatus === 1) {
              this.ParamsItem_PP = res.data.result
            } else if (this.JuridicalStatus === 2) {
              this.ParamsItem_LE = res.data.result
            }
            this.saveActionType = ''
            this.$swal({
              icon: 'success',
              title: 'ინცორმაცია!',
              html: '<span class="e-nusx-8 e-ts-09rem">მონაცემები დამახსოვრებულია!</span>',
              showCancelButton: false,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: 'გასაგებია',
              heightAuto: false,
              keydownListenerCapture: true
            })
          }
        })
      } else if (this.saveActionType === 'edit') {
        BaseService.EditAMLParameter(this.header, param).then((res) => {
          if (res.data.success) {
            this.saveActionType = ''
            this.$swal({
              icon: 'success',
              title: 'ინცორმაცია!',
              html: '<span class="e-nusx-8 e-ts-09rem">მონაცემები დამახსოვრებულია!</span>',
              showCancelButton: false,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: 'გასაგებია',
              heightAuto: false,
              keydownListenerCapture: true
            })
          }
        })
      } else {
        this.$swal({
          icon: 'danger',
          title: 'შეცდომა!',
          html: '<span class="e-nusx-8 e-ts-09rem">მოხდა სისტემური შეცდომა, გთხოვთ დაუკავშირდით CDC Screening-ის მხარდაჭერის ჯგუფს!</span>',
          showCancelButton: false,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'გასაგებია',
          heightAuto: false,
          keydownListenerCapture: true
        })
      }
    },
    clearForm () {
      this.ParamsItem_PP = {
        amlParameter: {
          id: 0,
          organisationId: 0,
          juridicalStatusId: 1,
          paramterTypeId: 1,
          parameterTypeName: 'scanning',
          scanningPacketId: 0,
          scanningDatabases: '',
          matchPercent: 0,
          checkInAcuris: true,
          logic1: false,
          logic2: false,
          logic3: false,
          organisationUserId: 0
        },
        scannigPacketDatabases: []
      }
      this.ParamsItem_LE = {
        amlParameter: {
          id: 0,
          organisationId: 0,
          juridicalStatusId: 2,
          paramterTypeId: 1,
          parameterTypeName: 'scanning',
          scanningPacketId: 0,
          scanningDatabases: '',
          matchPercent: 0,
          checkInAcuris: true,
          logic1: false,
          logic2: false,
          logic3: false,
          organisationUserId: 0
        },
        scannigPacketDatabases: []
      }
    },
    toggleAll (checked) {
      this.selectedPP = checked ? this.scannigPacketDatabases.slice() : []
    },
    toggleAllLE (checked) {
      this.selectedLE = checked ? this.scannigPacketDatabases.slice() : []
    }
  },
  watch: {
    selectedLE (newValue, oldValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminateLE = false
        this.allSelectedLE = false
      } else if (newValue.length === this.scannigPacketDatabases.length) {
        this.indeterminateLE = false
        this.allSelectedLE = true
      } else {
        this.indeterminateLE = true
        this.allSelectedLE = false
      }
    },
    selectedPP (newValue, oldValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminatePP = false
        this.allSelectedPP = false
      } else if (newValue.length === this.scannigPacketDatabases.length) {
        this.indeterminatePP = false
        this.allSelectedPP = true
      } else {
        this.indeterminatePP = true
        this.allSelectedPP = false
      }
    }
  }
}
</script>
